import Toggle from "@Components/shared/Toggle";
import { SwitchProps } from "antd";
import React, { memo } from "react";
import { Fixed, lerpColor } from "@Utils";
import ant from "@ant-design/charts";
import { ColumnConfig } from "@ant-design/plots";
import { PARTIAL_VISUALISATION_CONFIGURATION } from "@Components/shared/visualisationConstants";

interface IProps {
    target?: number;
    toggleOptions?: SwitchProps;
    imperial: boolean;
    value?: number;
}

const ColumnGraph: React.FC<IProps> = ({ target, toggleOptions, value, imperial }: IProps) => {
    const hasToggle = !!toggleOptions;

    const data = [
        {
            type: "User distance",
            value: Fixed(value),
        },
        {
            type: "Global average",
            value: Fixed(target),
        },
    ];

    const config: ColumnConfig = {
        ...PARTIAL_VISUALISATION_CONFIGURATION,
        data,
        xField: "type",
        yField: "value",
        label: {
            position: "middle",
            formatter: function formatter({ value }) {
                if (!value) {
                    return "";
                }
                return String(Fixed(value) + (imperial ? "yd" : "m"));
            },
            style: {
                fill: "#fff",
                fontSize: 20,
            },
        },
        tooltip: {
            formatter: ({ value }) => {
                if (!value) {
                    return { name: "Distance", value: "" };
                }
                return { name: "Distance", value: String(Fixed(value) + (imperial ? "yd" : "m")) };
            },
        },
        xAxis: {
            label: {
                autoHide: true,
                autoRotate: false,
            },
        },
        color: ({ type }) => {
            const alpha = type === "User distance" ? 0.1 : 0.3;
            return (
                "l(270)" +
                " 0:" +
                lerpColor("#457db0", "#5da3e3", "#a1c8eb", alpha) +
                " 1:" +
                lerpColor("#5887b3", "#7eacd7", "#a8c3db", alpha)
            );
        },
    };

    return (
        <div className="column-graph-toggle">
            <div style={{ marginBottom: "40px" }}>{hasToggle ? <Toggle {...toggleOptions} /> : null}</div>

            <ant.Column className="bullet-graph" {...config} />
        </div>
    );
};

export default memo(ColumnGraph);
